import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchHoofCareEntries } from "actions/hoof_care";
import Section from "components/layout/Section";
import Message from "components/message";
import EntryCardWithStatus from "components/cards/Entry_Card_With_Status";

class ViewEntries extends Component {
  UNSAFE_componentWillMount() {
    const { pet, hoofCare } = this.props;
    if (!hoofCare.fetched.includes(pet._id)) {
      this.props.fetchHoofCareEntries(pet);
    }
  }

  renderSectionContent() {
    const { hoofCare, cards, pet, defaultRoute } = this.props;
    const { entries } = hoofCare;

    const entriesFiltered = entries.filter((entry) => entry._pet === pet._id);

    if (entriesFiltered.length === 0) {
      return <Message warning message={"noEntriesToDisplayAutoFetch"} />;
    }

    return (
      <div className="columns is-2 is-variable is-mobile is-multiline is-centered">
        {entriesFiltered.map((entry, i) => (
          <div
            key={i}
            className="column is-full-mobile is-3-desktop is-4-tablet"
          >
            <EntryCardWithStatus
              hoofCareEntry
              to={`${defaultRoute}/view_entry/${entry._id}`}
              key={i}
              {...entry}
              messages={cards}
            />
          </div>
        ))}
      </div>
    );
  }

  render() {
    return <Section>{this.renderSectionContent()}</Section>;
  }
}

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      fetchHoofCareEntries,
      dispatch,
    },
    dispatch
  ),
});

export default connect(null, mapDispatchToProps)(ViewEntries);
